import View from 'ln/view/View';
import Node from 'ln/node/Node';

class RawHtmlElement extends View {

	constructor(  data:any = {} ) {
		
		super( data );
		this.defaultTemplate = 'lb.rawhtml-element';
	}

}


export default RawHtmlElement;